/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type AdminSection_organization$ref: FragmentReference;
declare export opaque type AdminSection_organization$fragmentType: AdminSection_organization$ref;
export type AdminSection_organization = {|
  +viewerIsSuperUser: boolean,
  +onRestrictedPlan: boolean,
  +viewer: {|
    +routes: {|
      +adminOrganizationPeoplePath: string,
      +adminOrganizationGlobalItemsPath: ?string,
      +adminOrganizationHabitsPath: ?string,
      +editAccountPath: string,
      +editAdminOrganizationPath: string,
      +adminBannerNoticesPath: ?string,
      +adminLessonsPath: ?string,
      +adminOfficeHoursPath: ?string,
      +adminReportsPath: ?string,
      +adminSearchOrganizationPath: ?string,
      +adminSearchPeoplePath: ?string,
      +announcementsPath: string,
      +deactivatedAdminOrganizationsPath: ?string,
      +metricsSummaryAdminOrganizationsPath: ?string,
      +adminAiContentEditPath: ?string,
    |}
  |},
  +$refType: AdminSection_organization$ref,
|};
export type AdminSection_organization$data = AdminSection_organization;
export type AdminSection_organization$key = {
  +$data?: AdminSection_organization$data,
  +$fragmentRefs: AdminSection_organization$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AdminSection_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerIsSuperUser",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "onRestrictedPlan",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Person",
      "kind": "LinkedField",
      "name": "viewer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Routes",
          "kind": "LinkedField",
          "name": "routes",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "adminOrganizationPeoplePath",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "adminOrganizationGlobalItemsPath",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "adminOrganizationHabitsPath",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "editAccountPath",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "editAdminOrganizationPath",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "adminBannerNoticesPath",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "adminLessonsPath",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "adminOfficeHoursPath",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "adminReportsPath",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "adminSearchOrganizationPath",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "adminSearchPeoplePath",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "announcementsPath",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "deactivatedAdminOrganizationsPath",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "metricsSummaryAdminOrganizationsPath",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "adminAiContentEditPath",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '9cf13580cd7fc0c5248f3181ac628839';

module.exports = node;
